import * as localforage from "localforage";
import { phpRequest } from "./phpRequest";

export const updateCompanyAPI = async (
  company_id,
  values,
  initCompanyImg,
  defaultImage
) => {
  let formData = new FormData();
  formData.append("id", company_id);
  formData.append("name", values.companyName);
  formData.append(
    "parent_company_id",
    values.parentCompany === "-" ? "" : values.parentCompany
  );
  formData.append("country_id", values.companyCountry);
  formData.append("region_id", values.companyRegion);
  formData.append("address", values.companyAddress);
  formData.append("contact_person", values.contactPerson);
  if (values.file) {
    formData.append("image", values.file[0]);
    if (initCompanyImg !== defaultImage) {
      // if there is already an old image
      formData.append("old_image", initCompanyImg);
    } else {
      formData.append("old_image", defaultImage);
    }
  }
  formData.append("phone", values.contactPhone);
  formData.append("email", values.contactMail);
  formData.append("inherit_personalize_config", values.inheritPersonalizeConfig);
  formData.append(
    "fec_customer_id",
    values.customID === "-" ? "" : values.customID
  );
  // formData.append("update_start", values.periodStart.format("HH:mm"));
  // formData.append("update_end", values.periodEnd.format("HH:mm"));
  const data = await phpRequest.post("/company/update", formData);

  // const params = {
  //   id: company_id,
  //   name: values.companyName,
  //   parent_company_id: values.parentCompany === "-" ? "" : values.parentCompany,
  //   country_id: values.companyCountry,
  //   region_id: values.companyRegion,
  //   address: values.companyAddress,
  //   contact_person: values.contactPerson,
  //   phone: values.contactPhone,
  //   email: values.contactMail,
  //   inherit_personalize_config: values.inheritPersonalizeConfig,
  //   fec_customer_id: values.customID === "-" ? "" : values.customID,
  // }
  // const data = await phpRequest.post("/company/update", params);

  //update Profile Card
  const userCompanyID = await localforage.getItem("userCompanyID");
  if (userCompanyID === company_id) {
    if (values.file) {
      localforage.setItem(
        "userCompanyImgLink",
        data.company.company_image_link
      );
    }
    if (values.contactPerson) {
      localforage.setItem("userCompanyContactPerson", values.contactPerson);
    }
    if (values.contactMail) {
      localforage.setItem("userCompanyMail", values.contactMail);
    }
    if (values.companyName) {
      localforage.setItem("userCompanyName", values.companyName);
    }
  }
};
